
export default {
  data() {
    return {
      title: "Buck Up For Bikes  | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "buckupforbikes",
          name: "buckupforbikes",
          content: "Raising funding For Bikes",
        },
      ],
    };
  },
};
